import React from 'react';
import { Text } from '../../../../CommonComponents/OPL/Text/Text';
import { ColumnHeader } from '../../../OtherAssets/OtherAssets.meta';
import { IncomeTable } from '../../components/IncomeTable/IncomeTable';
import { formatCurrency } from '../../../../CommonUtils/formatNumber';
import { TableActions } from '../../../OtherAssets/components/TableActions/TableActions';
import { IncomeTableProps } from '../../Income.meta';

const columnHeaders: ColumnHeader[] = [
  { text: 'Name' },
  { text: 'Earner' },
  { text: 'Salary', align: 'right' },
  { text: 'Bonus/Commissions', align: 'right' },
];

export const Employment = ({
  data,
  incomeType,
  setIncomeToUpsert,
  setIncomeToDelete,
  workflowProps,
}: IncomeTableProps) => {
  const {
    Options: { IncomeTypeOptions },
  } = data;

  const incomes = data.incomesDict[incomeType];

  const incomeTitle =
    IncomeTypeOptions.find(option => option.value === incomeType)?.label || 'Employment Income';

  return (
    <IncomeTable
      title={incomeTitle}
      isEmpty={incomes.length === 0}
      columnHeaders={columnHeaders}
      workflowProps={workflowProps}
    >
      {incomes.map(income => (
        <tr key={income.Id}>
          <td>
            <Text fontWeight={500} textAlign="left" width="100%">
              {income.Name}
            </Text>
          </td>

          <td>
            <Text fontWeight={500} textAlign="left">
              {income.Earner}
            </Text>
          </td>

          <td>
            <Text variant="tabular" fontWeight={500} textAlign="right">
              {income.Amount !== null ? formatCurrency(income.Amount) : '-'}
            </Text>
          </td>

          <td>
            <Text variant="tabular" fontWeight={500} textAlign="right">
              {income.BonusCommissions !== null ? formatCurrency(income.BonusCommissions) : '-'}
            </Text>
          </td>

          <TableActions
            assetName={incomeTitle}
            onEdit={() => setIncomeToUpsert(income)}
            onDelete={() => setIncomeToDelete({ id: income.Id, name: income.Name })}
          />
        </tr>
      ))}
    </IncomeTable>
  );
};
